class ProductModel extends DeferredMedia {
    constructor() {
        super();
    }

    loadContent() {
        // --- 强制挂载逻辑开始 ---
        if (!this.querySelector('model-viewer')) {
            const content = this.querySelector('template').content.firstElementChild.cloneNode(true);
            this.appendChild(content);
        }
        // --- 强制挂载逻辑结束 ---

        super.loadContent();

        Shopify.loadFeatures([
            {
                name: 'model-viewer-ui',
                version: '1.0',
                onLoad: this.setupModelViewerUI.bind(this),
            },
        ]);
    }

    setupModelViewerUI(errors) {
        if (errors) return;
    
        // 1. 先获取元素
        const modelViewerElement = this.querySelector('model-viewer');
    
        // 2. 如果元素不存在，直接返回，不执行初始化
        if (!modelViewerElement) {
            console.warn('Model viewer element not found inside', this);
            return;
        }
    
        // 3. 存在才执行初始化
        this.modelViewerUI = new Shopify.ModelViewerUI(modelViewerElement);
    }
}

customElements.define('product-model', ProductModel);

window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([
            {
                name: 'shopify-xr',
                version: '1.0',
                onLoad: this.setupShopifyXR.bind(this),
            },
        ]);
    },

    setupShopifyXR(errors) {
        if (errors) return;

        if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () =>
                this.setupShopifyXR()
            );

            return;
        }

        document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
            window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
            modelJSON.remove();
        });

        window.ShopifyXR.setupXRElements();
    },
};

window.addEventListener('DOMContentLoaded', () => { window.ProductModel?.loadShopifyXR(); });
